module.exports = __webpack_public_path__ + "0df90608875d9e335553a299c0f074a5.svg";